import { render, staticRenderFns } from "./aatkings-trip-info.vue?vue&type=template&id=f9ae74ec&scoped=true"
import script from "./aatkings-trip-info.vue?vue&type=script&lang=js"
export * from "./aatkings-trip-info.vue?vue&type=script&lang=js"
import style0 from "./aatkings-trip-info.vue?vue&type=style&index=0&id=f9ae74ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ae74ec",
  null
  
)

export default component.exports